<template>
    <div class="container justify-content-center">
        <div v-if="resetError" id="error-dialog" class="alert alert-danger">
          <strong>Error</strong> {{ resetError }}
        </div>
      </div>
      <div v-if="!emailSent && !passwordReset" class="login-container">
        <div class="login-form">
          <div class="form-group">
            <div class="input-container">
              <input
                type="text"
                id="username"
                v-model="email"
                required
              />
              <label
                id="username-label"
                class="input-label"
                >E-Mail</label
              >
            </div>
          </div>
          <button type="submit" class="submit-button m-1" v-on:click="sendRequest">Send Reset</button>
          <button class="submit-button m-1" v-on:click="handleCancel">Cancel</button>
        </div>
      </div>
      <div v-if="emailSent && !passwordReset" class="login-container">
        <div class="login-form">
          <div class="form-group">
            <div class="input-container">
              <input
                type="text"
                id="resetCode"
                v-model="resetCode"
                required
              />
              <label
                id="username-label"
                class="input-label"
                >Reset Code</label
              >
            </div>
            <div class="input-container">
              <input
                type="password"
                id="password"
                v-model="password"
                required
              />
              <label
                id="username-label"
                class="input-label"
                >New Password</label
              >
            </div>
          </div>
          <button class="submit-button m-1" v-on:click="resetPassword">Update Password</button>
        </div>
      </div>
      <div v-if="passwordReset">
        <div class="login-container">
          <div class="login-form">
            Password has been reset.
          </div>
          <button class="submit-button m-1" v-on:click="goBackToLogin">Back to Login</button>
        </div>
      </div>
    </template>
    
    <script>
    import { ref } from 'vue';
    import router from '@/router';
    import { setCookie } from '@/utils/cookies/cookieUtils.js'
    import { endpoint } from '@/utils/endpoint/endpointUtils.js'
  
    
    export default {
        components: {
  
        },
        data() {
            return {
                email: '',
                resetCode: '',
                password: '',
                emailSent: false,
                passwordReset: false,
                resetError: null
            };
        },
        methods: {
            async sendRequest() {
              const body = {
                email: this.email
              };

              try {
                const response = await fetch(endpoint + '/api/Authentication/RequestPasswordReset', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(body),
                });
                
                if (!response.ok) {
                  
                } else {
                  this.emailSent = true;
                }                
              } catch (exception) {
                console.log(exception);
              }              
            },
            async resetPassword() {
              const body = {
                email: this.email,
                requestCode: this.resetCode,
                password: this.password
              };

              try {
                const response = await fetch(endpoint + '/api/Authentication/VerifyResetPassword', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(body),
                });

                if (!response.ok) {

                } else {
                  const data = await response.json();
                  if (data.message === 'Success') {
                    this.passwordReset = true;
                    this.password = '';
                    this.email = '';
                    this.requestCode = '';
                  } else {
                    this.resetError = 'Could not reset password.';
                  }
                }

              } catch (exception) {
                console.log(exception);
              }

            },
            goBackToLogin() {
              this.emailSent = false;
              this.passwordReset = false;
              this.email = '';
              this.resetCode = '';
              this.password = '';
            },
            handleCancel() {
                this.$emit('cancel-clicked', true);
            }
        },
    };
    </script>
    
    <style>
    .login-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
    }
    
    .login-form {
      width: 400px;
      padding: 30px;
      border: 1px solid;
      border-radius: 5px;
      border-color: #4f4f4f;
    }
    
    .form-group {
      margin-bottom: 15px;
    }
    
    label {
      display: block;
      margin-bottom: 5px;
    }
    
    input[type="text"],
    input[type="password"] {
      width: 300px;
      padding: 8px;
      font-size: 16px;
      border: 1px solid #ccc;
      border-radius: 5px;
      border-color: rgb(62, 68, 70);
      background-color: #4f4f4f;
      color: cornsilk;
    }
    
    .submit-button {
      width: 300px;
      padding: 10px;
      background-color: #382d61;
      color: #fff;
      border: none;
      border-radius: 3px;
      cursor: pointer;
    }
    
    .submit-button:hover {
      background-color: #72018f;
    }
    .forgot-pass {
      margin: 10px;
      text-justify: right;
      text-align: right;
      width: auto;
      display: flex;
    }
    .register {
      text-justify: left;
      text-align: left;
      width: auto;
      display: flex;
    }
    
    .box {
      width: 100%;
    }
    
    .container {
      display: grid; /* Use CSS grid */
      grid-template-columns: auto auto; /* Set columns to auto size */
      grid-gap: 10px; /* Add gap between the boxes */
      margin-top: 20px;
    }
    
    .input-container {
      position: relative;
      margin-bottom: 20px; /* Add spacing between input fields */
    }
    
    .input-field {
      width: 100%;
      padding: 10px;
      font-size: 16px;
      border: 1px solid #ccc;
      border-radius: 5px;
    }
    
    .input-label {
      position: absolute;
      top: 50%;
      left: 60px;
      transform: translateY(-50%);
      color: #999;
      transition: all 0.3s ease; /* Add smooth transition effect */
    }
    
    .input-field:focus + .input-label,
    .input-field:not(:placeholder-shown) + .input-label {
      top: 5px;
      font-size: 12px;
      color: #333;
    }
    
    .input-label.active {
      top: 5px;
      font-size: 12px;
      color: #333;
      display: none;
    }
    </style>
    